module.exports = __webpack_public_path__ + "img/main-title.6606e51b.png";